var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcAlignRight02({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "align-right-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M5.80135 3.8901L8.82604 7.00121M8.82604 7.00121L5.80135 10.1123M8.82604 7.00121L1.35938 7.00122M11.3149 11.979L11.3149 2.02344",
    stroke: "#116584",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAlignRight02);
export default __webpack_public_path__ + "static/media/ic-align-right-02.2e9965170799fe97c9d90ec5e3118871.svg";
export { ForwardRef as ReactComponent };